<template>
    <div id="s-navSide">

    <span v-show="menuOpen">
        <b-navbar toggleable="lg" :type="getTheme.dark" :variant="getTheme.dark" fixed="top" class="borderB">
            <b-navbar-brand>
                <img src="../../../assets/nav/logo_gl.png" class="d-inline-block align-top cursorPoint" alt="logo" @click="menuOpen=!menuOpen">    
            </b-navbar-brand>  
            <b-navbar-brand>
                <img src="../../../assets/nav/logo_service.png" class="d-inline-block align-top cursorPoint" alt="logo" @click="menuOpen=!menuOpen">    
            </b-navbar-brand>  
            <b-navbar-brand>
                <img src="../../../assets/nav/logo_pos.png" class="d-inline-block align-top cursorPoint" alt="logo" @click="menuOpen=!menuOpen">    
            </b-navbar-brand>  
        </b-navbar>
    </span> 

<span v-show="!menuOpen">
      <b-navbar toggleable="lg" :type="getTheme.dark" :variant="getTheme.dark" fixed="top" class="borderB">
        <b-navbar-brand>
            <img src="../../../assets/nav/logo_gl.png" class="d-inline-block align-top cursorPoint" alt="logo" @click="menuOpen=!menuOpen">    
        </b-navbar-brand>       

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>      

        <b-collapse id="nav-collapse" is-nav>      

        <b-navbar-nav class="ml-auto">

            <!--CODE DE RÉSOLUTION D'ÉCRAN-->
            <b-navbar-nav>
                <b-nav-item @click="pushto('/')">{{ getScreenSize.width }}:{{ getScreenSize.height }}</b-nav-item>
            </b-navbar-nav> 

            <!--<b-nav-item-dropdown text="Documentations">
                <b-dropdown-item @click="pushto('/documentation/css')">CSS</b-dropdown-item>
            </b-nav-item-dropdown>-->
            <b-navbar-nav>
                <b-nav-item @click="pushto('/documentation/css')">Documentations</b-nav-item>
            </b-navbar-nav>  

            <b-navbar-nav>
                <b-nav-item @click="pushto('/')">{{ $t('m_Accueil') }}</b-nav-item>
            </b-navbar-nav>  

            <b-nav-item-dropdown :text="$t('m_Comptabilites')">
                <b-dropdown-item @click="pushto('/accounting/account')">{{ $t('m_Comptes') }}</b-dropdown-item>
                <b-dropdown-item @click="pushto('/accounting/transactions')">{{ $t('m_Transactions') }}</b-dropdown-item>
                <b-dropdown-item @click="pushto('/accounting/inscription')">{{ $t('m_Inscription') }}</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown :text="$t('m_Facturations')">
                <b-dropdown-item @click="pushto('/invoicing/clients')">{{ $t('m_Clients') }}</b-dropdown-item>
                <b-dropdown-item @click="pushto('/invoicing/invoices')">{{ $t('m_Factures') }}</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown :text="$t('m_Configurations')">
                <b-dropdown-item @click="pushto('/configurations/exercises')">{{ $t('m_Exercices') }}</b-dropdown-item>
                <b-dropdown-item @click="pushto('/configurations/taxes')">{{ $t('m_Taxes') }}</b-dropdown-item>
                <b-dropdown-item @click="pushto('/configurations/employees')">{{ $t('m_Employes') }}</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown :text="$t('m_Licence')">
                <b-dropdown-item v-for="(magList, index) in licence" :key="magList.index" @click="changeWorkLicence(licence[index])">{{ licence[index] }}</b-dropdown-item>
                <!--<b-dropdown-item v-for="(magList, index) in licence" :key="magList.index" @click="changeWorkLicence(licence[index])">{{ licence[index] }}</b-dropdown-item>
                <b-dropdown-item v-for="(magList, index) in licence" :key="magList.index" @click="changeWorkLicence(licence[index])">{{ licence[index] }}</b-dropdown-item>-->
            </b-nav-item-dropdown>

            <b-nav-item class="licence">{{getworkLicence}}</b-nav-item>

        </b-navbar-nav>


          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">       

            <!--TAXES-->
            <b-nav-item-dropdown :text="$t('m_Taxes') + ' ' + getActiveTaxes.stateFr" right>
            <!--<b-nav-item-dropdown :text="$t('m_Taxes')" right>-->
              <span v-for="(item) in getTaxes" :key="item.index">
                <b-dropdown-item @click="$setTaxes(item.codeTax)">{{item["state" + myLng]}}</b-dropdown-item>
              </span>
            </b-nav-item-dropdown>   
            <!--SELECTION LANGUE-->
            <b-nav-item-dropdown :text="$t('m_Langue')" right>
              <b-dropdown-item @click="changeLang('fr')">Français</b-dropdown-item>
              <b-dropdown-item @click="changeLang('en')">English</b-dropdown-item>
            </b-nav-item-dropdown>     
            <!--UTILISATEUR-->
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                {{$t('m_Utilisateur')}}
              </template>
              <h5 class="profileNom">{{getUser.nom}}</h5>
              <b-dropdown-item @click="pushto('/user')">{{$t('m_Profil')}}</b-dropdown-item>
              <b-dropdown-item @click="pushto('/loadedData')">{{$t('m_DonneesCharges')}}</b-dropdown-item>
              <b-dropdown-item @click="Logout()">{{$t('m_Sortir')}}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </span> 

    </div>
</template>



<script>

import {mapGetters} from 'vuex'

export default{
name: 's-navSide',
data() {
    return {
        licence: [],
        menuOpen: false,
        myLng: 'Fr'
    }
},
created() {
    window.addEventListener("resize", this.onResize);
},
destroyed() {
    window.removeEventListener("resize", this.onResize);
},
computed: {
    ...mapGetters(['getTheme', 'changeLanguage', 'getUser', 'getworkLicence', 'getScreenSize', 'getTaxes', 'getActiveTaxes']),
},
methods: {
        createLicence() {
            this.licence = this.getUser.licenceList.split(";") 
        },
        pushto(link) {
            console.log(link)
            this.$router.push(link)
        },
        changeLang(lng){
            this.$i18n.locale = lng //Changer la langue
            this.$store.commit('changeLanguage', lng)

            if(lng == 'fr')
                {this.myLng = 'Fr'}
            else
                {this.myLng = 'En'}

        },
        changeWorkLicence(licence){
            this.$store.commit('changeworkLicence', licence)
        },
        Logout(){
            this.$store.dispatch('setUser', null) //Effacer l'utilisateur du store
            this.$store.commit('changeLogin', false) //Mettre le login a off pour le retour à la page Login
            this.pushto('/')
        },
        // eslint-disable-next-line no-unused-vars
        onResize(e) {
            this.$store.commit('changeScreenSizeW', window.innerWidth)
            this.$store.commit('changeScreenSizeH', window.innerHeight)
        },
    },
    mounted() {
        this.createLicence() //charger les licences
        this.$store.commit('changeScreenSizeW', window.innerWidth)
        this.$store.commit('changeScreenSizeH', window.innerHeight)
    }
    //watch: {
    //    getLanguage: function() {
    //        if(this.getLanguage == 'fr')
    //            {this.myLng = 'Fr'}
    //        else
    //            {this.myLng = 'En'}
    //    }
    //}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/components/navSide.scss'
</style>